import $ from 'jquery';

$(() => {
  // tree views
  const trees = $('.tree');
  if (trees.length) {
    // open to active
    trees.find('.active').parents('.parent').toggleClass('in', true);

    // toggle click handling
    trees.find('li.parent > div > .tree-box').on('click', function (e) {
      var li = $(this).parent().parent();
      if (li.hasClass('in')) {
        li.toggleClass('in', false);
      } else {
        li.toggleClass('in', true);
      }
      e.stopPropagation();
    });
    trees.on('click', '.add > .tree-box', function (e) {
      $(e.currentTarget).parent().find('a')[0].click();
    });
  }
});
